export default "__VITE_ASSET__Cx_qMpGH__"